/*
 *
 * Authorization API Actions
 *
 */

import {
  NOT_ASKED,
  MAKE_REQUEST,
  LOADING,
  FAILURE,
  SUCCESS,
  CLEAR,
} from './constants';

export function notAsked() {
  return {
    type: NOT_ASKED,
  };
}

export function makeRequest(params) {
  return {
    type: MAKE_REQUEST,
    params,
  };
}

export function loading(params) {
  return {
    type: LOADING,
    params,
  };
}

export function failure(error) {
  return {
    type: FAILURE,
    error,
  };
}

export function success(results) {
  return {
    type: SUCCESS,
    results,
  };
}

export function clear(results) {
  return {
    type: CLEAR,
    results,
  };
}



// WEBPACK FOOTER //
// ./src/services/LoginType/actions.js